import { Component, inject } from '@angular/core';
import { SidenavGroupItem } from '../../types/sidebar-group.models';
import { Roles } from '../../types/role.enum';
import { UserType } from '../../types/user-type.enum';
import { AuthService } from '../../libs/auth/auth.service';

@Component({
	standalone: false,
	selector: 'bt-sidenav',
	templateUrl: './sidenav.component.html',
	styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent {
	readonly authService = inject(AuthService);

	get userType(): string {
		return this.authService.userLoggedValue?.UserType;
	}

	allSidenavGroups: Array<SidenavGroupItem> = [
		{
			groupUrlPart: 'company',
			userType: UserType.COMPANY,
			groupItems: [
				{
					menuLabel: 'Orders',
					menuRoute: 'order-list',
					icon: 'fa-solid fa-images',
					requiredRoles: [Roles.ORDER_LIST],
					childRoutes: ['order-view', 'order-info']
				},
				{
					menuLabel: 'Styles',
					menuRoute: 'style-list',
					icon: 'fa-solid fa-shirt',
					requiredRoles: [Roles.STYLE_LIST],
					childRoutes: ['style-info']
				},

				{
					menuLabel: 'Templates',
					menuRoute: 'template-list',
					icon: 'fa-regular fa-object-group',
					requiredRoles: [Roles.TEMPLATE_LIST],
					childRoutes: ['template-detail']
				},
				{
					menuLabel: 'Photographers',
					menuRoute: 'photographer-list',
					icon: 'fa-solid fa-user-group',
					requiredRoles: [Roles.PHOTOGRAPHER_LIST],
					childRoutes: []
				}
			]
		},
		{
			groupUrlPart: 'photographer',
			userType: UserType.PHOTOGRAPHER,
			groupItems: [
				{
					menuLabel: 'Orders',
					menuRoute: 'order-list',
					icon: 'fa-solid fa-images',
					requiredRoles: [Roles.ORDER_LIST],
					childRoutes: ['order-view', 'order-info']
				}
			]
		}
	];
}
